import React, { useEffect, useState } from 'react';
import Input from 'components/input/input.component';
import Select from 'components/select/select.component';
import { DictionaryKey, getDictionary } from 'requests/dictionary.request';
import { IKpu } from 'interfaces/applicant.interface';

interface IProps {
  kpu: IKpu;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const ComPortConnection: React.FC<IProps> = ({ kpu, handleChange }) => {
  const [dictionaries, setDictionaries] = useState<Record<string, string[]>>({});

  const handleGetDictionary = (key: DictionaryKey) => {
    getDictionary(key)
      .then((res) => setDictionaries((prevState) => ({ ...prevState, [key]: res })))
      .catch(() => setDictionaries((prevState) => ({ ...prevState, [key]: [] })));
  };

  useEffect(() => {
    handleGetDictionary('parity');
    handleGetDictionary('stop-bits');
  }, []);

  return (
    <>
      <Input name="comPort" value={kpu.comPort || ''} label={'COM port'} onChange={handleChange} />
      <Input
        name="baudRate"
        value={kpu.baudRate || ''}
        label={'Baud rate'}
        onChange={handleChange}
      />
      <Input
        name="dataBits"
        value={kpu.dataBits || ''}
        label={'Data bits'}
        onChange={handleChange}
      />
      <Input
        name="readTimeout"
        value={kpu.readTimeout || ''}
        label={'Read timeout'}
        onChange={handleChange}
      />
      <Input
        name="writeTimeout"
        value={kpu.writeTimeout || ''}
        label={'Write timeout'}
        onChange={handleChange}
      />
      <Select
        label={'Parity'}
        name={'parity'}
        options={dictionaries['parity']}
        value={kpu.parity || ''}
        onChange={handleChange}
      />
      <Select
        label={'Stop bits'}
        name={'stopBits'}
        options={dictionaries['stop-bits']}
        value={kpu.stopBits || ''}
        onChange={handleChange}
      />
    </>
  );
};

export default ComPortConnection;
